/* Dr. Elias Saab's videos.
   1. Starting one video stops any other one on the page.
   2. The wheel (sections/doctor-videos.liquid with "Loop the videos as a
      wheel"): an endless row. Moving on slides the row one video and then
      moves the first video to the end (or the last to the front), so it never
      runs out. It turns by itself every 6 seconds, but never while a video is
      playing, the pointer is over it, it has keyboard focus, or it is off
      screen; with "reduce motion" it does not turn by itself and does not slide. */
(function () {
  if (window.__drVideos) return; window.__drVideos = true;

  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!v || !v.matches || !v.matches('video[data-dr-video]')) return;
    document.querySelectorAll('video[data-dr-video]').forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
  }, true);

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // cards: cover + one play button; the player's controls appear once it plays
  function card(c) {
    var v = c.querySelector('video'), btn = c.querySelector('[data-drv-play]');
    if (!v || !btn) return;
    v.controls = false; btn.hidden = false;
    btn.addEventListener('click', function () {
      c.classList.add('is-playing'); v.controls = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      try { v.focus({ preventScroll: true }); } catch (e) {}   // the button hides; focus moves to the player
    });
    // scrolled out of view: it stops playing (and downloading)
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting && !v.paused) v.pause();
      }, { threshold: 0.2 }).observe(v);
    }
    v.addEventListener('play', function () { c.classList.add('is-playing'); v.controls = true; });
    v.addEventListener('ended', function () { reset(c); });
  }
  function reset(c) {
    var v = c.querySelector('video');
    if (v && !v.paused) v.pause();
    c.classList.remove('is-playing');
    if (v) v.controls = false;
  }

  function wheel(root) {
    var viewport = root.querySelector('[data-drv-viewport]');
    var track = root.querySelector('[data-drv-track]');
    if (!viewport || !track || track.children.length < 2) return;
    var busy = false, hover = false, focus = false, visible = true, timer = null;
    var rtl = getComputedStyle(root).direction === 'rtl';

    function step() {
      var first = track.children[0];
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function playing() {
      return Array.prototype.some.call(track.querySelectorAll('video'), function (v) { return !v.paused && !v.ended; });
    }
    function stopVideos() { track.querySelectorAll('[data-drv-card]').forEach(reset); }
    var countEl = root.querySelector('[data-drv-count]'), n = track.children.length, idx = 0;
    function show(d) {
      idx = (idx + d + n) % n;
      if (countEl) countEl.textContent = ('0' + (idx + 1)).slice(-2);
    }
    function set(x, animate) {
      track.style.transition = animate && !reduce ? 'transform .45s ease' : 'none';
      track.style.transform = x ? 'translateX(' + x + 'px)' : '';
    }
    function after(fn) {
      if (reduce) { fn(); return; }
      var done = false;
      function end() { if (done) return; done = true; track.removeEventListener('transitionend', end); fn(); }
      track.addEventListener('transitionend', end);
      setTimeout(end, 600);
    }
    // forward = toward the end of the row in the reading direction
    function next() {
      if (busy) return; busy = true; stopVideos();
      var d = step() * (rtl ? 1 : -1);
      set(d, true); show(1);
      after(function () { track.appendChild(track.children[0]); set(0, false); busy = false; });
    }
    function prev() {
      if (busy) return; busy = true; stopVideos();
      var d = step() * (rtl ? 1 : -1);
      track.insertBefore(track.lastElementChild, track.children[0]);
      set(d, false);
      void track.offsetWidth;
      set(0, true); show(-1);
      after(function () { busy = false; });
    }

    root.querySelector('[data-drv-next]').addEventListener('click', function () { next(); restart(); });
    root.querySelector('[data-drv-prev]').addEventListener('click', function () { prev(); restart(); });

    // swipe on touch screens only, so mouse clicks on the player controls are untouched
    var sx = null, sy = null;
    viewport.addEventListener('touchstart', function (e) {
      /* a touch on a playing video belongs to its own controls (seek bar,
         volume): it must not swipe the wheel away from the video */
      var v = e.target.closest && e.target.closest('video');
      if (v && !v.paused) { sx = null; return; }
      var t = e.touches[0]; sx = t.clientX; sy = t.clientY;
    }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; sx = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      var towardStart = rtl ? dx < 0 : dx > 0;
      (towardStart ? prev : next)(); restart();
    });

    // a real mouse only: on a phone a tap fired mouseenter and nothing ever cleared it
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hover = false; });
    root.addEventListener('focusin', function () { focus = true; });
    root.addEventListener('focusout', function (e) { focus = !!(e.relatedTarget && root.contains(e.relatedTarget)); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.3 }).observe(root);
    }
    /* a visible pause, so the turning can be stopped on a phone too */
    var stopped = false, pauseBtn = root.querySelector('[data-drv-pause]');
    if (pauseBtn) {
      if (reduce) { pauseBtn.hidden = true; }
      pauseBtn.addEventListener('click', function () {
        stopped = !stopped;
        pauseBtn.setAttribute('aria-pressed', stopped ? 'true' : 'false');
        pauseBtn.classList.toggle('is-stopped', stopped);
      });
    }
    function tick() { if (!stopped && !hover && !focus && visible && !document.hidden && !playing()) next(); }
    function restart() { if (reduce) return; clearInterval(timer); timer = setInterval(tick, 6000); }
    restart();
  }

  function init() {
    document.querySelectorAll('[data-drv-card]').forEach(card);
    document.querySelectorAll('[data-drv-wheel]').forEach(wheel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
